// List of all user-facing strings passed to t('...') throughout the app
const ALL_TRANSLATION_KEYS = [
  'Neurolonic', 'Beta', 'Hi,', 'Dashboard', 'Login', 'Get Started', 'Help', 'Toggle theme', 'Theme', 'Light', 'Dark', 'Device',
  'Wellbeing intelligence', 'Choose your plan', 'Access for individuals, clinicians, teams, schools and athletes.',
  'Home', 'Contact', 'Footer', 'All rights reserved.',
  'Analyze Another', 'Speak up, seek help,', 'and soar towards', 'a brighter tomorrow', 'Subscribe to prioritize', 'your mental health today',
  'User Details', 'Name', 'Age', 'Gender', 'Role', 'Reset Password', 'Deactivate Account',
  'Are you sure you want to delete your account? This action cannot be undone.', 'Yes, Delete', 'Cancel', 'Enter new password', 'Re-type new password',
  'Save Password', 'Password updated successfully.', 'Failed to update password.', 'Welcome to Xi', 'Welcome to Neurolonic!', 'Sign up now', "Don't have an account?",
  'Your Subscription Plan', 'Upgrade Plan', 'Processing...', 'Recording... Tap to stop.', 'Tap mic to speak', 'Bot:', 'No reply text.', 'Bot failed to respond.', 'Ask the Monster Bot!',
  'Individual', 'For personal mental wellness tracking and emotional support', 'Continue', 'Doctor', 'Access patient tools, predictions & insights',
  'Corporate', 'Team wellness dashboard, performance & HR insights', 'School / University', 'Student mental health ecosystem & dashboard',
  'Sports Management', 'Emotional + cognitive tracking for athletes', 'Go to home page', 'Join Xi - Choose', 'Join Neurolonic - Choose', 'Your Role to Get Started',
  'Sign up as an individual or as part of an organization to unlock', 'tailored mental wellness tools and AI-powered features',
  'Close login modal', 'Username', 'Enter username', 'Password', 'Enter password', 'Please select a role.', 'Passwords do not match.',
  'Signup failed. Please try again.', 'Sign Up', 'Already have an account?', 'Log in now', 'Close Signup', 'Select', 'Male', 'Female', 'LGBTQ',
  'Create Password', 'Create password', 'Confirm Password', 'Confirm password', 'User not logged in!', 'Failed to load dashboard. ', 'log in',
  'Loading your mental health dashboard...', 'No weekly data yet. Please upload more voice samples to view your weekly report!', 'Mood swings/week', 'Angry', 'Frustration', 'Impatience', 'Mental state', 'Top emotions', 'No monthly data yet. Come back after a few weeks!', 'No yearly data yet. Stick with it for a year to see your journey!', 'Yearly progress', 'Primary emotion', 'Subcategory', 'Sub-subcategory', 'Weekly', 'Monthly', 'Yearly',
  'Stop recording', 'Start recording', 'Upload File', 'Microphone access denied or not available.',
  'Help & Commands', 'BOT command and action:', 'Say', 'login', 'login screen', 'Signup', 'signup screen', 'Dashboard screen', 'get started', 'get started screen', 'Upload', 'upload option comes', 'record', 'record options starts', 'Analyse', 'analyse options comes', 'speechbot', 'or', 'talk to bot', 'you can chat freely with own native language', 'Manual option:', 'Click mic (on/off) - for start and stop recording. Please speak less than 10 sec. We limited for beta version 1 and later on we increase size of recording.',
  'Contact Sales Team', 'Contact the Neurolonic sales team at', 'Close popup', 'Audio Waveform & Mel-Spectrogram', 'Emotion Radar', 'Emotional Analysis', 'Mental State:', "If you're in crisis or need help, please reach out to a mental health professional or emergency support line.", 'Top 5 chart',
  'Close Subscription Modal', 'Your Subscription Plan', 'Upgrade Plan',
  // Pricing section keys
  'Free Plan', 'Premium Plan', 'Companion AI', 'Donation Option',
  '$0', '$100', '$10', '+$25', 'Custom', 'Custom Pricing',
  '/year', '/month', 'or',
  'Weekly emotional/mental state reports', 'Basic quizzes', 'Basic mood tracker',
  'Monthly & Yearly emotion trends', 'Mental health dashboard', 'Unlimited emotional tracking', 'Sub-sub emotion insights', 'No ads',
  'Speech-to-speech real-time AI chat', 'Personality customization (virtual companion)', 'Monthly data sync',
  'Pay-what-you-want to support mental health access for low-income individuals',
  'Team Starter (up to 10 employees)', '$79',
  'Basic mental health insights', 'Mood trends', 'Employee support channel',
  'Growth Plan (up to 50)', '$249', 'Monthly/yearly mental health data', 'Group mood heatmaps', 'Productivity correlation insights',
  'Enterprise (100+ employees)', '(starts at $499/month)', 'Full integration', 'Custom onboarding', 'Mental health workshops', 'Partner psychologist access',
  'Basic Doctor Dashboard', '$29', 'Add & manage patient list', 'Weekly reports per patient', 'Basic analytics',
  'Advanced Doctor Insights', '$59', 'All Basic + Monthly/Yearly analytics', 'Graphs per patient', 'Exportable reports', 'Speech-based entry',
  'Clinic Team License', '$149', 'Up to 5 professionals', 'Shared patient records', 'Role-based access', 'Admin control',
  'Education Starter (small schools)', '$49', 'Emotional check-ins', 'Weekly reports for students',
  'Academic Wellness (universities)', '$149', 'Class-wise emotion graphs', 'Student mental health states', 'AI-based recommendations',
  'Institution Plan', 'Custom', '(e.g. $299–$499/month)', 'Large-scale integration', 'Department reports', 'Annual trend analysis', 'Family dashboard access',
  'Coach Lite', 'Pro Sports Plan', 'Elite Plan', '$99', '$199', 'Athlete mental status tracker', 'Pre/post game reports', 'Emotional state prediction', 'Performance + stress correlation', 'Athlete mental dashboard', 'Team-level analytics', 'Doctor collaboration', 'Longitudinal performance trends',
  'Add-ons for All Plans', 'Data Export / PDF Report→ +$5/month', 'Multi-language Support→ +$3/month', 'Zero-Knowledge Proof & Blockchain Encryption→ +$7/month (Premium security layer)',
  // Corporate Dashboard keys
  'Corporate Well-being Dashboard', 'Conduct Session', 'Add Dept', 'Add Staff',
  'Filter by Department', 'All Departments', 'Employee Mood Tracking',
  'Delete staff member', 'Emotion:', 'Motivation:', 'Burnout Risk', 'Select Employee',
  'Select an employee...', 'No data available for this department.', 'Department Overview',
  'employees', 'View Reports', 'Delete department', 'Select Department',
  'Select a department...', 'Show All Departments', 'Hide All Departments',
  'avg', 'risk', 'Burnout Risk Alerts', 'No Data', 'Burnout Risk',
  'Employees', 'Low', 'Moderate', 'High', 'Risk Distribution',
  'No session data available', 'Conduct sessions to view burnout risk distribution',
  'Low Risk', 'Moderate Risk', 'High Risk', 'Red Zone Employees',
  'Flag Reasons:', 'No behavioral flags recorded.', 'View Details',
  'Career Motivation Tracker', 'Overall Motivation Index', '/ 100',
  'Current data', 'Motivation Trend (Past 2 Weeks)', 'No data available',
  'Low Motivation Employees', 'View Suggestions',
  'No session data available - Conduct sessions to view motivation levels',
  'All employees have healthy motivation levels',
  'Reports & Trends', 'Weekly Aggregates', 'Average Emotion Score',
  'Burnout Flag Count', 'Motivation Score Trend', 'Intervention Suggestions',
  'High emotion scores detected', 'Low motivation scores', 'Burnout risk detected',
  'No session data available - Conduct sessions to generate intervention suggestions',
  'No immediate interventions needed - All metrics are within healthy ranges',
  'Loading session data...', 'No Sessions Conducted Yet',
  "This staff member hasn't had any wellness sessions conducted yet.",
  'Conduct a session to view detailed analytics, trends, and personalized coaching suggestions.',
  'Conduct Session Now', "What you'll see after conducting a session:",
  'Comprehensive wellness metrics (Emotion, Motivation, Burnout, etc.)',
  'Trend analysis and timeline charts', 'Wellness radar visualization',
  'Risk assessment and flags', 'Personalized coaching suggestions',
  'Comprehensive Report Overview', 'Total Sessions', 'Average Emotion',
  'Average Motivation', 'Risk Level', 'Current Metrics', 'Engagement',
  'Stress', 'Wellbeing', 'Wellness Radar - Current vs Previous Session',
  'Current Session', 'Previous Session',
  'Comprehensive Metrics Timeline', 'Emotion Timeline',
  'No timeline data available. Conduct a session to see emotion trends.',
  'Risk Assessment', 'Trend Analysis', 'Burnout Trend', 'Stress Trend',
  'Engagement Trend', 'Flag History',
  'No flags recorded. All metrics are within normal ranges.',
  'Session-by-Session Breakdown', 'Coaching Suggestions',
  "Based on this session's scores, focus on the following next steps:",
  'Not enough data to generate weekly report.', 'Conduct sessions to generate report data.',
  'Weekly Report', 'Summary', 'Top Flagged Issues',
  'Not enough data to generate monthly report.', 'Monthly Report',
  'Department Overview', 'Loading session data for report...',
  'Weekly', 'Monthly', 'Participation', 'Burnout Risk Distribution',
  'Total Sessions', 'Top Flagged Risks', 'Engagement Trend',
  'Not enough data to generate report.',
  'Conduct sessions for department staff to generate report data.',
  'Department Name', 'Top Emotion:', 'Emotion', 'Motivation',
  'Wellbeing', 'Sessions:', 'Positive', 'Neutral', 'Negative',
  'Medium Risk', 'Add New Department', 'Department Name *',
  'Enter department name', 'Create Department', 'Add New Staff Member',
  'Name *', 'Enter staff member name', 'Email', 'Enter email address (optional)',
  'Role', 'Select role (optional)', 'Other (type below)', 'Enter custom role',
  'Department *', 'Select Department', 'Cancel', 'Add Staff',
  'Delete Department?', 'Delete Staff Member?',
  'This action cannot be undone.', 'Confirm Delete',
  'Select Department', 'Select Staff Member', 'Conduct Session',
  'Department', 'Staff', 'Session', 'Choose a department to view available staff members',
  'Search departments...', 'No departments found matching',
  'No departments available. Please add a department first.',
  'Select a staff member from', 'Search staff members...', 'No email',
  'No staff members found matching', 'No staff members in this department.',
  'Back to Departments',
  'Record continuous audio for exactly 40 seconds. The recording will be automatically split into 5 chunks of 8 seconds each for analysis.',
  'Record 5 audio segments, each exactly 8 seconds. After each segment completes, the next one will start automatically.',
  'Continuous Recording', 'Complete ✓', 'Re-record',
  'of 5 recorded — Click to continue', 'Start Recording',
  'Resume', 'Pause', 'Discard & Restart',
  'Processing...', 'Submit Session', 'Back to Staff',
  'Please stop recording before changing mode',
  'Recording already completed. Please discard to record again.',
  'All 5 recordings are complete',
  'Session completed and saved successfully!',
  'No staff selected', 'No valid emotion data calculated. Session may have failed to process correctly.',
   'Loading...', 'Save',
  // Additional corporate dashboard keys
  'Average Emotion', 'Average Motivation', 'Average Engagement', 'Average Stress',
  'View detailed reports and analytics for this department',
  // User profile editing keys
  'Edit Profile', 'Profile', 'Update your account information',
  'Preferred Language', 'Phone Number', 'Job Title', 'Profile Picture',
  // Department average keys
  'No completed emotion assessments',
  // Home.jsx User Details keys
  'Save Changes', 'Update Profile', 'Profile updated successfully.',
  'Failed to update profile.', 'Edit', 'Cancel',
  'Schedule team wellness sessions', 'Consider recognition programs',
  'Review workload and provide support',
  // Add more as needed from other components
  // Privacy Policy modal keys
  'Privacy Policy', 'Close privacy policy', 'Welcome to Neurolonic!', 'At Neurolonic, we are deeply committed to protecting your privacy and ensuring the security of your data. Please review the following privacy agreement before using our services.',
  'Data Collection and Use', 'Your audio recordings, as well as any resulting emotion and mental state analyses, will be securely stored on a private, encrypted cloud.', 'These data are used exclusively for providing you with insights into your emotional and mental states.',
  'Data Privacy', 'We do not share or sell your data to any third parties. All personal and audio data remain strictly confidential.', 'Only you have access to your data, and it will never be disclosed or accessible by any unauthorized personnel.',
  'Professional Access After Launch', 'After the official product launch, only certified professionals within Neurolonic may review data, solely for support and quality improvement purposes, and only with your explicit consent.',
  'Security Measures', 'We employ industry-standard encryption and privacy safeguards to protect your data. Our team continuously monitors and updates our security protocols to maintain the highest level of data protection.',
  'By signing up and using Neurolonic, you agree to this privacy policy and understand that your data will remain secure and confidential. Thank you for trusting Neurolonic with your journey.',
  'Agree', 'Decline',
  // DoctorDashboard keys
  'Total Patients',
  'High Risk Patients',
  "Today's Sessions",
  'Weekly Growth',
  'Daily Growth',
  'Last Session',
  'No recent sessions',
  'Next Session',
  'No upcoming sessions',
  'All Patients',
  'Add Patient',
  'Status',
  'Actions',
  'Report',
  'Add Session',
  'History',
  'Edit',
  'Delete',
  'Patient Details',
  'Last Mental Health',
  'Overall Mark',
  'Risk Score',
  'School / University Dashboard',
  'Students',
  'Staff',
  'Add Student',
  'Edit Student',
  'No students yet',
  'Add Staff',
  'Edit Staff',
  'No staff yet',
  'Class',
  'Last session',
  'Clear',
  'History',
  'Start',
  'Pause',
  'Recording…',
  'Recording 8s…',
  'Source',
  'Loading history…',
  'No history available yet.',
  'Date',
  'Calm',
  'Stressed',
  'Anxious',
  'Demotivated',
  'Hurt',
  'Notes',
  'Top Emotion',
  'Burnout Score',
  'Show Emotion Breakdown',
  'Behavioral Flags',
  'Select a student to start session and view reports',
  'Burnout & Academic Stress Risk',
  'Behavioral Deviation',
  'Flags Raised This Week',
  'Learning Readiness',
  'Motivated',
  'Partially Ready',
  'Disengaged',
  'Emotional Well-being Indicators',
  'Concerns Identified',
  'Work Engagement & Resilience',
  'High Engagement',
  'Moderate',
  'At Risk',
  'Recent Uploads',
  'Session Controls',
  'Click mic up to 5 times. Each records 8s and aggregates results.',
  'Start Segment',
  'Data source',
  'Session Notes',
  'Live transcription and notes...',
  '🎤 Recording… Click Stop to transcribe.',
  '⏳ Transcribing…',
  'Error occurred',
  'Start Note',
  'Stop',
  'Save Note',
  'Notes History',
  'Delete note',
  'No notes yet.',
  'Section',
  'Contact',
  'Other',
  'Save',
  'Please enter student name',
  'Failed to save student',
  'Failed to delete student',
  'Please enter staff name',
  'Failed to save staff',
  'Failed to delete staff',
  'Nothing to save',
  'Finish a recording session first to attach notes.',
  'Note saved',
  'Failed to save note. Try again.',
  'Failed to delete note',
  'Microphone access denied or recording failed',
  'Select a student or staff member first',
  'No trend data available yet.',
  'No change',
  'Mental Well-being',
  'Change',
  'Sessions Count',
  'Avg Calm',
  'Avg Burnout',
  'Avg Stressed',
  'Recommendation',
  'Loading',
  'insights…',
  'Excellent emotional health. Continue maintaining positive habits.',
  'Good stability observed. Keep consistency in emotional routines.',
  'Fluctuations detected. Consider stress management and mindfulness strategies.',
  'Decline in emotional state observed. Recommend professional support and closer monitoring.',
  'Transcription error',
  // Hospital Dashboard keys
  'Doctors',
  'Sessions',
  'High Risk',
  'Reports',
  'No data available for',
  'report',
  'High Risk Patients',
  'No high-risk patients currently',
  'Doctor',
  'Unassigned',
  'N/A',
  'Doctor Performance / Load Balance',
  'Upcoming Appointments',
  'Patient',
  'Date / Time',
  'No upcoming appointments',
  'Loading...',
  'Email',
  'Role/Specialization',
  'Active',
  'View Patients',
  'No doctors yet. Add your first doctor.',
  'No doctors found matching',
  'No patients found',
  'No patients found for this doctor',
  'matching',
  'No Data',
  'Not Scheduled',
  'Schedule Appointment',
  'Add New Doctor',
  'Phone',
  'Display Name',
  'Other',
  'e.g., Psychiatrist, Psychologist, Therapist',
  'Create Doctor',
  'Add New Patient',
  'Select Doctor',
  'Address',
  'Create Patient',
  // Hospital Doctor Dashboard keys
  'Hospital Doctor Dashboard',
  'My Patients',
  'Scheduled Sessions',
  'Assigned Patients',
  'No patients assigned yet.',
  'Search patients by name, contact, status, or age...',
  'No patients found matching',
  'Appointment Soon',
  'Last Session',
  'None',
  'Not scheduled',
  'Start Session',
  'No scheduled sessions.',
  'Date & Time',
  'Purpose',
  'Duration',
  'Action',
  'Unknown',
  'min',
  'Upcoming',
  'Past',
  'Ready to Start',
  'Patient not found',
  'Session with',
  'Progress',
  'recordings completed',
  'Total time',
  'Recording segment',
  'seconds',
  'Analyzing segment',
  'Start Recording (1/5)',
  'Record Next Segment',
  'All Recordings Complete',
  'Saving...',
  'Save Session',
  'Session History',
  'View Details',
  'Close',
  'Session Details',
  'Please complete all 5 recordings before saving',
  'Error saving session. Please try again.'
];

export default ALL_TRANSLATION_KEYS; 